import { DefaultPrivacyLevel, datadogRum } from "@datadog/browser-rum";

export class DatadogRumService {
  public static Init() {
    if (process.env.VUE_APP_TYPE_ENV === "0") return;

    datadogRum.init({
      applicationId: process.env.VUE_APP_DatadogApplicationID || "",
      clientToken: process.env.VUE_APP_DatadogClientToken || "",
      site: "datadoghq.com",
      service: process.env.VUE_APP_DatadogService,
      env: process.env.VUE_APP_DatadogEnv,
      sampleRate: Number(process.env.VUE_APP_DatadogSampleRate) || 100,
      premiumSampleRate: Number(process.env.VUE_APP_DatadogPremiumSampleRate) || 100,
      tracingSampleRate: Number(process.env.VUE_APP_DatadogTracingSampleRate) || 100,
      trackInteractions: true,
      defaultPrivacyLevel: (process.env.VUE_APP_DatadogSessionReplayPrivacy as DefaultPrivacyLevel) || "",
      useSecureSessionCookie: true,
      allowedTracingOrigins: [
        process.env.VUE_APP_PeakExportService || "",
        process.env.VUE_APP_PeakRealTimeService || "",
        process.env.VUE_APP_PeakPayrollService || "",
        process.env.VUE_APP_PeakAuthenService || "",
        process.env.VUE_APP_PeakTaxService || "",
      ],
    });
    datadogRum.startSessionReplayRecording();
  }

  public static SetUserFromUserInfo(userInfo: { id: number; given_name: string; userEmail: string }) {
    if (process.env.VUE_APP_TYPE_ENV === "0") return;
    if (!userInfo) return;

    datadogRum.setUser({
      id: String(userInfo.id),
      name: userInfo.given_name,
      email: userInfo.userEmail,
    });
  }

  public static RemoveUser() {
    if (process.env.VUE_APP_TYPE_ENV === "0") return;

    datadogRum.removeUser();
  }
}
